import type { ThunkReturnType } from "types";
import { SetupIdentifier } from "consts/setups";
import { when } from "util/support";
import type { ConstantsResponse } from "features/general/types";
import { getConstantsThunk } from "features/general/thunks";
import useCountries from "features/general/useCountries";
import useUserPreferences from "features/general/useUserPreferences";
import useMerchantActions from "features/merchants/useMerchantActions";
import usePaymentMethodActions from "features/paymentMethods/useActions";
import useSetupsActions from "features/setups/useActions";
import useBitsoBanks from "features/general/useBitsoBanks";
import { selectIsNotMor } from "features/auth/selectors";
import { useRequest } from "./useRequest";
import useSessionEffect from "./useSessionEffect";
import { useTypedSelector } from "./store";

const dashboardSessionEffectSymbol = Symbol('dashboardSessionEffectSymbol');

export default function useDashboardBootstrap() {
    const isNotMor = useTypedSelector(selectIsNotMor);

    const getConstants = useRequest<ThunkReturnType<ConstantsResponse>, void>({
        thunk: getConstantsThunk
    });

    useUserPreferences({
        shouldFetchUserPreferences: true
    });

    const { getAllPaymentMethods } = usePaymentMethodActions();

    const { getAllMerchants } = useMerchantActions();

    const { getSetupByIdentifier } = useSetupsActions();

    useCountries();

    useBitsoBanks();

    useSessionEffect(() => {
        getConstants();
        getAllPaymentMethods();
        when(isNotMor, () => getSetupByIdentifier(SetupIdentifier.Mors));
        getAllMerchants();
    }, dashboardSessionEffectSymbol);
};
